import { render, staticRenderFns } from "./upLoadAvatar.vue?vue&type=template&id=44807ddb&scoped=true&"
import script from "./upLoadAvatar.vue?vue&type=script&lang=js&"
export * from "./upLoadAvatar.vue?vue&type=script&lang=js&"
import style0 from "./upLoadAvatar.vue?vue&type=style&index=0&id=44807ddb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44807ddb",
  null
  
)

export default component.exports